<template>
<div class="badges-wrap">
    <div class="header">
        <div style="width:20%;display:inline-block">
            <h3>{{ $t('adminNav.badges') }}</h3>
        </div>
        <div style="width:80%;display:inline-block" v-if="!$route.meta.requiresAdmin">
            <h3 style="text-align:right;font-family:'Roboto',sans-serif;font-weight:500;font-size:14px;line-height:22px" v-if="missingPoints > 0">You earned <b>{{ userPoints ? userPoints : '0' }}</b> credits! You need <b>{{missingPoints}}  credits for the next badge!</b></h3>
            <h3 style="text-align:right;font-family:'Roboto',sans-serif;font-weight:500;font-size:14px;line-height:22px" v-else>You earned <b>{{ userPoints ? userPoints : '0' }}</b> credits! Congrats, you've won all the badges!</h3>
        </div>
    </div>
    <div class="border"></div>
    <div class="badges">
        <UserBadge 
            v-for="badge in badges"
            :key="badge.id"
            :badge="badge"
            @badge="$emit('badge', $event)"
            @delete-badge="$emit('delete-badge', $event)"
        />
    </div>	
</div>
</template>

<script>
import UserBadge from "./UserBadge.vue";
export default {
    components: {
        UserBadge,
    },
    props: {
        badges: {
            type: Array,
            required: true,
        },
        userPoints: {
            type: Number,
            required: true,
        }
    },
  data() {
    return {
      missingPoints: 0,
    };
  },
    emits: ['badge'],
    mounted() {
      this.init();
  },
  methods: {
    init() {
        this.calculatePointsForNewBadge();
    },
    calculatePointsForNewBadge(){
        this.missingPoints = 0;
        let currentPoints = this.userPoints;
        let isAlreadySet = false;
        this.badges.forEach(badge => {
        let badgePoints = badge.bgd_min;
            if(this.userPoints < badgePoints && !isAlreadySet){
                this.missingPoints = badgePoints - currentPoints;
                isAlreadySet = true;
            }
        });
    },
  },
}
</script>

<style lang="scss" scoped>
.badges-wrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    .header {
        h3 {
          font-family: 'Roboto', sans-serif;
          font-size: 18px;
          line-height: 32px;
          font-weight: 700;
          color: #001529;
          margin: 0;
          margin-bottom: 10px;
          margin-top: -10px;
        }
    }
    .border {
      $ant-padding: 24px;
      height: 1px;
      width: calc(100% + #{$ant-padding * 2});
      transform: translateX(calc(0px - #{$ant-padding}));
      background-color: #DFE1E6;
    }
    .badges {
        margin-top: 15px;
        display: flex;
        flex-wrap: wrap;
        gap: 0 2em;
    }
}
</style>